import React from "react"
import { Icon } from "../../Icon"
import styled from "styled-components"

export const MobileFlexSearchBtn = ({ onOpenModal }) => {
  return (
    <FlexSearchBtn onClick={() => onOpenModal()}>
      <Icon type="SEARCH_ICON" fill="black" width="16" height="16" />
    </FlexSearchBtn>
  )
}

const FlexSearchBtn = styled.button`
  cursor: pointer;
  border: 1px solid white;
  width: 24px;
  height: 24px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.primary_color};
  transition: 0.3s ease-in-out;

  &:hover {
    background-color: ${({ theme }) => theme.colors.secondary_color};
  }

  @media (min-width: ${({ theme }) => theme.media.desktop_min}) {
    display: none;
  }
`
